import {useMemo} from 'react';
import {useFilters} from './useFilter';
import useCurrentPageCursor from './useCurrentPageCursor';
import {NO_FILTER_QUERY_PARAMS} from '../constants';

const useProductFilters = () => {
  const {filters: appliedFilters = {}} = useFilters();
  const {currentPage} = useCurrentPageCursor();

  const facetsFilter = useMemo(() => {
    const {sort, ...rest} = appliedFilters;

    return Object.keys(rest)
      .filter(k => rest[k].length > 0)
      .filter(k => !NO_FILTER_QUERY_PARAMS.includes(k)) // If a query param is in the exception list, don't create a filter
      .map(k => ({key: k, values: rest[k]}));
  }, [appliedFilters]);

  return {
    after: currentPage,
    filter: {
      facets: facetsFilter,
    },
    pageSize: 100,
    sort: appliedFilters.sort,
  };
};

export default useProductFilters;
